define('bindingHandlers/audio/audioPlayerNavigation',[
    'lib/lodash4',
    'lib/knockout',
    'util/keyCode',
    'jquery'
], function (_, ko, keyCode, $) {
    'use strict';

    /**
     * <p>Binding for calculating the position within a scrubber control where click events occurs</p>
     * <p>This binding also calculates the final position of the position indicator control within the scrubber when it is dragged.</p>
     * <p>
     * This binding adds a click handler to elements that will calculate the
     * percentage-wise position that the event occurred within the scrubber control. Currently, along
     * it only calculates position on the x-axis and it is constrained to clicks or mouse drag
     * within the client area of the control.To utilize this binding handler, add
     * the following to your HTML tag's data-bind attribute:
     *
     *   data-bind="audioPlayerNavigation: someEventCallback"
     *
     * a properly formatted element might look like this
     *
     *   <div data-bind="audioPlayerNavigation: handleAudioPlayerNavigation">
     *   </div>
     *
     * Where handleAudioPlayerNavigation is a callback function on the ViewModel that your template is
     * referencing that accepts arguments of (percentPosition, event)
     * </p>
     * @exports bindingHandlers/audioPlayerNavigation
     */
    ko.bindingHandlers.audioPlayerNavigation = {
        init: function (element, valueAccessor) {

            var SCRUBBER_CLASS = "scrubber-position-indicator";
            var eventNameSpace = SCRUBBER_CLASS + '-' + _.uniqueId();
            var DISPLACEMENT    = 10;

            var onScrubberNavigation = ko.unwrap(valueAccessor());

            var processDragPosition = function(x,target,event){
                var $positionIndicator = $(event.currentTarget);
                var indicatorWidth     = $positionIndicator.width();
                var scrubberWidth      = target.width();
                var limitLeftPos       = 0;
                var limitRightPos      = scrubberWidth - indicatorWidth;

                if (x < limitLeftPos)  {
                    x = limitLeftPos;
                }

                if (x > limitRightPos){
                    x = limitRightPos;
                }

                var percentPosition = x / scrubberWidth;
                if (percentPosition <= 100) {
                    onScrubberNavigation(percentPosition, event);
                }
            };

            var processNewPosition = function(x,target,event){
                if (x > 0 && x < target.width()) {
                    var percentPosition = x / target.width();
                    if (percentPosition <= 100) {
                        onScrubberNavigation(percentPosition, event);
                    }
                }
            };

            /**
             * Handles user key events
             */
            var handleKey = function(event){
                var newDisplacement=0;
                var trackbarPos = $(event.target).position().left;

                switch(event.which){
                case keyCode.LEFT:
                    newDisplacement -= DISPLACEMENT;
                    break;
                case keyCode.RIGHT:
                    newDisplacement += DISPLACEMENT;
                    break;
                case keyCode.ENTER:
                    event.preventDefault();
                    return;
                default:
                    return;
                }

                var sliderPos = trackbarPos + newDisplacement;
                processNewPosition(sliderPos,$(element),event);
            };

            $(element).on('click.'+eventNameSpace, function (event) {
                var target = $(event.currentTarget);
                if (target) {
                    var targetOffset = target.offset();
                    if (event.pageY > targetOffset.top &&
                        event.pageY < (targetOffset.top + target.height()))
                    {
                        var x = event.pageX - targetOffset.left;
                        processNewPosition(x,target,event);
                    }
                }
                return false;
            });

            var $positionIndicator = $("."+SCRUBBER_CLASS,element.parentNode);

            $positionIndicator.on('keydown.'+eventNameSpace,handleKey);

            $positionIndicator.on('click.'+eventNameSpace,function(event){
                event.preventDefault();
            });

            $positionIndicator.on('mousedown.'+eventNameSpace, function (mousedownEvent) {
                mousedownEvent.preventDefault();
                $(document).on('mousemove.'+eventNameSpace,function(ev){
                    var target =$(element);
                    if (target) {
                        var targetOffset = target.offset();
                        var x = ev.pageX - targetOffset.left;
                        processDragPosition(x,target,mousedownEvent);
                    }
                });
            });

            $(document).on('mouseup.'+eventNameSpace, function () {
                $(document).off('mousemove.'+eventNameSpace);
            });

            // Clean up the binding handler when the element is removed from the DOM.
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(element).off("."+eventNameSpace);
                $(document).off("."+eventNameSpace);
            });
        }
    };
});

